var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99181 15.0821L8.84588 3.24329C9.22469 2.58899 9.4141 2.26184 9.6612 2.15196C9.87675 2.05612 10.1228 2.05612 10.3384 2.15196C10.5855 2.26184 10.7749 2.58899 11.1537 3.24329L18.0078 15.0821C18.3879 15.7388 18.578 16.0671 18.5499 16.3366C18.5254 16.5716 18.4023 16.7852 18.2111 16.9242C17.992 17.0835 17.6126 17.0835 16.8539 17.0835H3.14572C2.38695 17.0835 2.00756 17.0835 1.78843 16.9242C1.5973 16.7852 1.47416 16.5716 1.44965 16.3366C1.42156 16.0671 1.61164 15.7388 1.99181 15.0821Z",
    fill: "#165AE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99979 7.50019V10.8335M9.99979 14.1669H10.0081M8.84588 3.24329L1.99181 15.0821C1.61164 15.7388 1.42156 16.0671 1.44965 16.3366C1.47416 16.5716 1.5973 16.7852 1.78843 16.9242C2.00756 17.0835 2.38695 17.0835 3.14572 17.0835H16.8539C17.6126 17.0835 17.992 17.0835 18.2111 16.9242C18.4023 16.7852 18.5254 16.5716 18.5499 16.3366C18.578 16.0671 18.3879 15.7388 18.0078 15.0821L11.1537 3.24329C10.7749 2.58899 10.5855 2.26184 10.3384 2.15196C10.1228 2.05612 9.87675 2.05612 9.6612 2.15196C9.4141 2.26184 9.22469 2.58899 8.84588 3.24329Z",
    stroke: "#165AE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99979 7.5V10.8333M9.99979 14.1667H10.0081",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.fcc33b18dae33963a91e2ca4707523ec.svg";
export { ForwardRef as ReactComponent };